var exports = {
  "n": "x31de4314--b8a111--row",
  "A": "x31de4314--b8a111--item",
};

module.exports = exports;
